// removed by extract-text-webpack-plugin
module.exports = {"everything-wrapper":"WorkPage__everything-wrapper___1T7VD","everything-separator":"WorkPage__everything-separator___2UYiJ"};


//////////////////
// WEBPACK FOOTER
// ./application/js/pages/WorkPage.css
// module id = 531
// module chunks = 0